<div class="backpage-wrapper">
  <div class="credential-library-container padding s6 all">
    <app-sat-admin-stepper></app-sat-admin-stepper>
  </div>
</div>
